import { useEffect, useState } from 'react';

import AutoscalingActivationCardIcon from '~/shared/assets/icons/autoscaling-storage-potential.svg';
import CircularProgress from '~/shared/components/CircularProgress';
import KPICard from '~/shared/components/KPICard';
import { KPIHeader, KPIMetricColumn } from '~/shared/components/kpi';

const PROGRESS_SIZE_DEFAULT = 78;
const PROGRESS_SIZE_LARGE = 98;

interface AutoscalingActivationCardCardProps {
  currentSize: string;
  fullPotentialSize: string;
  managedVolumes: string;
  potentiallySupportedVolumes: string;
  progressPercentage: number;
  loading: boolean;
}

const BREAKPOINT_WIDTH = 1920;
export default function AutoscalingActivationCardCard({
  currentSize,
  fullPotentialSize,
  managedVolumes,
  potentiallySupportedVolumes,
  progressPercentage,
  loading,
}: AutoscalingActivationCardCardProps) {
  const [progressSize, setProgressSize] = useState(PROGRESS_SIZE_DEFAULT);

  useEffect(() => {
    const mediaQuery = window.matchMedia(`(min-width: ${BREAKPOINT_WIDTH}px)`);
    const updateSize = () => {
      setProgressSize(mediaQuery.matches ? PROGRESS_SIZE_LARGE : PROGRESS_SIZE_DEFAULT);
    };

    updateSize();
    mediaQuery.addEventListener('change', updateSize);
    return () => mediaQuery.removeEventListener('change', updateSize);
  }, []);

  return (
    <KPICard className="flex flex-col justify-between min-w-[460px] 4xl:min-w-[520px] w-full relative">
      <div className="flex items-start justify-between gap-3">
        <KPIHeader
          icon={AutoscalingActivationCardIcon}
          title="Autoscaling Activation"
          subtitle="Currently managed out of total potentially supported"
        />
        <div className="h-full absolute right-0 top-0 flex pt-3 4xl:pt-0 4xl:items-center justify-center px-3">
          <CircularProgress
            percentage={progressPercentage}
            loading={loading}
            size={progressSize}
            strokeWidth={8}
          />
        </div>
      </div>

      <div className="flex gap-2 4xl:gap-3 items-end font-family-outfit">
        <KPIMetricColumn
          label="Managed Volumes"
          value={currentSize}
          volumeLabel={managedVolumes}
          loading={loading}
        />
        <KPIMetricColumn
          label="Potentially Supported Volumes"
          value={fullPotentialSize}
          volumeLabel={potentiallySupportedVolumes}
          loading={loading}
        />
      </div>
    </KPICard>
  );
}
